import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./home/home.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgxMaskModule } from "ngx-mask";
import { MisionControlComponent } from "./mision-control/mision-control.component";
import { ComponentsModule } from "../components/components.module";
import { LoginComponent } from "./login/login.component";

@NgModule({
  declarations: [HomeComponent, MisionControlComponent, LoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
  ],
})
export class PagesModule {}
